/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the "Elastic License
 * 2.0", the "GNU Affero General Public License v3.0 only", and the "Server Side
 * Public License v 1"; you may not use this file except in compliance with, at
 * your election, the "Elastic License 2.0", the "GNU Affero General Public
 * License v3.0 only", or the "Server Side Public License, v 1".
 */

import { escapeKuery, escapeQuotes } from '..';
export const KQL_NODE_TYPE_LITERAL = 'literal';
export function isNode(node) {
  return node.type === KQL_NODE_TYPE_LITERAL;
}
export function buildNode(value, isQuoted = false) {
  return {
    type: KQL_NODE_TYPE_LITERAL,
    value,
    isQuoted
  };
}
export function toElasticsearchQuery(node) {
  return node.value;
}
export function toKqlExpression(node) {
  return node.isQuoted ? `"${escapeQuotes(`${node.value}`)}"` : escapeKuery(`${node.value}`);
}